import React, { useState, useEffect } from 'react';
import '../styles/Node.css';
import { db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import Withdraw from './Withdraw';
import Trade from './Trade';
import Loader from '../components/Loader';
import Deposit from '../components/Deposit';
import Donate from '../components/Donate'; 
import MarketMarquee from './MarketMarquee';
import FxtNode from '../components/FxtNode';


const Node = ({ user }) => {
    const [isDepositVisible, setDepositVisible] = useState(false);
    const [isWithdrawVisible, setWithdrawVisible] = useState(false);
    const [isTradeVisible, setTradeVisible] = useState(false);
    const [isDonateVisible, setDonateVisible] = useState(false); 
    const [accountBalances, setAccountBalances] = useState({});
    const [walletAddress, setWalletAddress] = useState({});
    const [loading, setLoading] = useState(true);

    // Fetch wallet address
    useEffect(() => {
        const fetchWalletData = async () => {
            try {
                const docRef = doc(db, 'shipments', 'chief');
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setWalletAddress(docSnap.data());
                } else {
                    console.error("No wallet data found!");
                }
            } catch (error) {
                console.error("Error fetching wallet data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchWalletData();
    }, []);

    // Fetch user balances
    useEffect(() => {
        const fetchBalances = async () => {
            try {
                const userDoc = await getDoc(doc(db, 'bit-lite', user.uid));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    const balances = {};
                    (userData.transactions || []).forEach((txn) => {
                        if (['Investments', 'Trading'].includes(txn.account)) {
                            balances[txn.account] = balances[txn.account] || 0;
                            balances[txn.account] += txn.type === 'credit' ? txn.amount : -txn.amount;
                        }
                    });
                    setAccountBalances(balances);
                }
            } catch (err) {
                console.error("Error fetching balances:", err);
            }
        };

        if (user?.uid) {
            fetchBalances();
        }
    }, [user]);

    // Modal Handlers
    const handleOpenModal = (modal) => {
        if (modal === 'deposit') setDepositVisible(true);
        if (modal === 'withdraw') setWithdrawVisible(true);
        if (modal === 'trade') setTradeVisible(true);
        if (modal === 'donate') setDonateVisible(true);  // <-- Add donate handler
    };

    const handleCloseModal = (modal) => {
        if (modal === 'deposit') setDepositVisible(false);
        if (modal === 'withdraw') setWithdrawVisible(false);
        if (modal === 'trade') setTradeVisible(false);
        if (modal === 'donate') setDonateVisible(false);  // <-- Add donate handler
    };

    if (loading) return <Loader />;

    return (
        <div className="transaction-container" id="investments">
            <div className="node-content-wrapper">
                {/* Market chart and data below */}
                <MarketMarquee />


                {/* This is the right side box (now shown above chart on mobile) */}
                <FxtNode
                    accountBalances={accountBalances}
                    handleOpenModal={handleOpenModal}
                />
            </div>

            {/* Deposit Modal */}
            {isDepositVisible && (
                <Deposit
                    loading={loading}
                    walletAddress={walletAddress}
                    handleCloseModal={handleCloseModal}
                />
            )}

            {/* Withdraw Modal */}
            {isWithdrawVisible && (
                <>
                    <div className="overlaid" onClick={() => handleCloseModal('withdraw')}></div>
                    <div className="USDT-deposit">
                        <Withdraw user={user} accountBalances={accountBalances} />
                        <span className="close" onClick={() => handleCloseModal('withdraw')}>
                            &times; Close
                        </span>
                    </div>
                </>
            )}

            {/* Trade Modal */}
            {isTradeVisible && (
                <>
                    <div className="overlaid" onClick={() => handleCloseModal('trade')}></div>
                    <div className="USDT-deposit">
                        <Trade user={user} accountBalances={accountBalances} />
                        <span className="close" onClick={() => handleCloseModal('trade')}>
                            &times; Close
                        </span>
                    </div>
                </>
            )}

            {/* Donate Modal */}
            {isDonateVisible && (
                <>
                    <div className="overlaid" onClick={() => handleCloseModal('donate')}></div>
                    <div className="USDT-deposit">
                        <Donate walletAddress={walletAddress} />
                        <span className="close" onClick={() => handleCloseModal('donate')}>
                            &times; Close
                        </span>
                    </div>
                </>
            )}
        </div>
    );
};

export default Node;
